import React, { Fragment, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Router from 'components/routers/router';
import { locSetLanguage } from '../redux/actions/localization.actions';
import { LANG_SERVICE_DEFAULT } from 'services/LanguageService/languageService.types';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
function App() {
    var dispatch = useDispatch();
    var currentLang = useSelector(function (state) { return state.localization.language; });
    var rank = useSelector(function (state) { return state.userAuthorization.userSession.rank; });
    var i18n = useTranslation().i18n;
    var setLanguage = function (lang, i18n) { return dispatch(locSetLanguage(lang, i18n)); };
    useEffect(function () {
        setLanguage(currentLang || LANG_SERVICE_DEFAULT, i18n);
        moment.locale(currentLang || LANG_SERVICE_DEFAULT);
    }, []);
    return (React.createElement(Fragment, null,
        React.createElement(Router, { rank: rank })));
}
export default App;
